<p-messages key="info"></p-messages>
<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="row">
    <div class="col-md-8">
        <h6 class="prd-h6">Import E-filed Applications</h6>
    </div>
    <div class="col-md-3 offset-1">
        <label for="calYear" style="padding-right: 10px;"><strong>Calendar Year:</strong></label>
        <select id="calYear" style="width: 150px;" title="Select a year" [(ngModel)]="myYear" class="form form-input" (change)="selectYear($event)">
            <option *ngFor="let yr of yearList" [ngValue]="yr">{{yr}}</option>
        </select>
    </div>
</div>
<hr />
<div class="card" *ngIf='displayState.workingDiv'>
    <div class="card-body">
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>

<div class="card bg-light" *ngIf='!displayState.workingDiv' style="margin-top: 5px;">
    <div class="card-body" style="margin-bottom: 3px;">
        <!-- Grid -->
        <div class="row" *ngIf="displayState.indexDiv">
            <!--  grid appears here    -->
            <p-table #efileCases [columns]="cols" [value]="applicationList" [responsive]="true" [scrollable]="true" scrollHeight="450px" [(selection)]="selectedCases" dataKey="applicationId" >
                <ng-template pTemplate="caption">
                    <div class="ui-table-globalfilter-container">
                        <input type="text" pInputText size="40" [(ngModel)]="filterOptions.filterText" placeholder="Global Filter" title="Enter text for which to search" (change)="efileCases.filterGlobal($event.target.value, 'contains')" style="width:200px;">
                    </div>
                    &nbsp;&nbsp;&nbsp;
                    <strong>E-Filed Applications for {{this.myYear}}</strong>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="width: 7%;">{{ cols[0].header }}</th>
                        <th style="width: 20%;">{{ cols[1].header }}</th>
                        <th style="width: 10%;">{{ cols[2].header }}</th>
                        <th style="width: 25%;">{{ cols[3].header }}</th>
                        <th style="width: 20%;">{{ cols[4].header }}</th>
                        <th style="width: 5%;"></th>
                        <th style="width: 5%;"></th>
                        <th style="width: 5%;"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-case>
                    <tr>
                        <td style="width: 7%;">{{ case.dateUpdated | date:"MM/dd/yyyy" }}</td>
                        <td style="width: 20%;">{{ case.applicantName }}</td>
                        <td style="width: 10%;">{{ case.parcelNumber }}</td>
                        <td style="width: 25%;" title="{{case.propertyLocationView}}">{{ case.propertyLocationView }}</td>
                        <td style="width: 20%;">{{ case.agentName }}</td>
                        <td style="width: 5%;"><button id="editBtn" [disabled]="!allowImport" type="button" class="btn btn-link btn-sm" (click)="importApplication(case)">Import</button></td>
                        <td style="width: 5%;"><button id="viewBtn" type="button" class="btn btn-link btn-sm" (click)="viewDoc(case)">View</button></td>
                        <td style="width: 5%"><button id="rejectBtn" type="button" class="btn btn-danger btn-sm" [hidden]="!allowReject" (click)="rejectApp(case)">Reject</button></td>
                    </tr>
                </ng-template>
                <ng-template *ngIf="applicationList.length>0" pTemplate="summary">
                    <div class="row">
                        <div class="col-md-2 offset-1" style="text-align: left;"># of cases: {{ applicationList.length }}</div>
                    </div>
                </ng-template>
            </p-table>
        </div>

        <!-- Applicant -->
        <div class="container" *ngIf="displayState.applicantDiv" style="background-color: gainsboro; border: thin; border-radius: 5px; padding: 5px;">
            <br />
            <div class="row">
                <div class="col-md-1 col-md-offset-1">
                    <b>Applicant</b>
                </div>
                <div class="col-md-6" style="background-color: lightyellow; font-size: large">
                    {{efiledData.applicantFullName}} {{efiledData.applicantDto.mailingAddress}} {{efiledData.applicantDto.city }}
                </div>
            </div>

            <br />

            <div class="row">
                <div class="col-md-11 col-md-offset-1">
                    Search to try to match applicant with existing entries to avoid creating duplicate applicant records.
                </div>
            </div>

            <div class="row">
                <div class="col-md-4 col-md-offset-1">
                    <input type="text" class="form-control" [(ngModel)]="searchString.applicantName" />
                </div>
                <div class="col-md-5">
                    <button class="btn-primary btn-sm" (click)="getApplicantList()">Search</button>
                </div>
            </div>

            <div class="row" *ngIf="applicantList.length>0">
                <br />
                <div class="col-md-11 col-md-offset-1">
                    <table class="table table-bordered" style="border-radius: 5px; background-color: white">
                        <tr>
                            <td><a (click)="clearApplicantList()" class="aPointer"> Clear applicant lookup </a></td>
                            <td>&nbsp</td>
                            <td>&nbsp</td>
                            <td>&nbsp</td>
                            <td>&nbsp</td>
                            <td>&nbsp</td>
                        </tr>
                        <tr *ngFor="let item of applicantList">
                            <td> <a (click)="applicantSelected(item); " class="aPointer"> {{item.name}} </a> </td>
                            <td> {{item.strAddr}} </td>
                            <td> {{item.city}} </td>
                            <td> {{item.state}} </td>
                            <td> {{item.phone}} </td>
                            <td> {{item.email}} </td>
                        </tr>
                    </table>
                </div>
            </div>

            <br />

            <!-- Buttons -->
            <div class="row">
                <div class="col-md-2 col-md-offset-1">
                    <button class="btn btn-cancel" (click)="cancelImport()">Cancel Import</button>
                </div>
                <div class="col-md-3">
                    <button class="btn btn-cancel" (click)="applicantNoMatch()" value="Create new applicant in appeals database.">No Existing Applicant Match</button>
                </div>
            </div>
            <br />

        </div>

        <!-- Agent -->
        <div class="container" *ngIf="displayState.agentDiv" style="background-color: gainsboro; border: thin; border-radius: 5px; padding: 5px;">
            <br />
            <div class="row">
                <div class="col-md-1 col-md-offset-1">
                    <b>Agent</b>
                </div>
                <div class="col-md-6" style="background-color: lightyellow; font-size: large">
                    {{efiledData.agentDto.companyName}} {{efiledData.agentDto.mailingAddress}} {{efiledData.agentDto.city }}
                </div>
            </div>

            <br />

            <div class="row">
                <div class="col-md-11 col-md-offset-1">
                    Search to try to match agent with existing entries to avoid creating duplicate agent records.
                </div>
            </div>

            <div class="row">
                <div class="col-md-4 col-md-offset-1">
                    <input type="text" class="form-control" [(ngModel)]="searchString.agentName" />
                </div>
                <div class="col-md-5">
                    <button class="btn-primary btn-sm" (click)="getAgencyList()">Search</button>
                </div>
            </div>

            <div class="row" *ngIf="agencyList.length > 0">
                <br />
                <div class="col-md-11 col-md-offset-1">
                    <table class="table table-bordered" style="border-radius: 5px; background-color: white">
                        <tr>
                            <td><a (click)="clearAgencyList()" class="aPointer"> Clear agent lookup </a></td>
                            <td>&nbsp</td>
                            <td>&nbsp</td>
                            <td>&nbsp</td>
                            <td>&nbsp</td>
                            <td>&nbsp</td>
                        </tr>
                        <tr *ngFor="let item of agencyList">
                            <td> <a (click)="agencySelected(item); " class="aPointer"> {{item.name}} </a> </td>
                            <td> {{item.strAddr}} </td>
                            <td> {{item.city}} </td>
                            <td> {{item.state}} </td>
                            <td> {{item.phone}} </td>
                            <td> {{item.email}} </td>
                        </tr>
                    </table>
                </div>
            </div>

            <br />

            <!-- Buttons -->
            <div class="row">
                <div class="col-md-2 col-md-offset-1">
                    <button class="btn btn-cancel" (click)="cancelImport()">Cancel Import</button>
                </div>
                <div class="col-md-3">
                    <button class="btn btn-cancel" (click)="agentNoMatch()" value="Create new agent in appeals database.">No Existing Agent Match</button>
                </div>
            </div>
            <br />
        </div>

        <!-- Summary Div-->
        <div class="container" *ngIf="displayState.summaryDiv" style="background-color: gainsboro; border: thin; border-radius: 5px;">
            <br />

            <div class="form-row" *ngIf="!efiledData.applicantMatchedId">
                <label for="appName" class="col-md-1 col-form-label prd-label">Applicant</label>
                <input id="appName" class="form-control col-md-3" [(ngModel)]='efiledData.applicantFullName' readonly>
                <label for="appAPN" class="col-md-1 col-form-label prd-label">APN</label>
                <input id="appAPN" class="form-control col-md-2" [(ngModel)]='efiledData.parcelNumber' readonly>
                <label for="appSitus" class="col-md-1 col-form-label prd-label">Situs/Loc</label>
                <input id="appSitus" class="form-control col-md-3" [(ngModel)]='efiledData.situs' readonly>
            </div>
          <br />
          <div class="form-row" *ngIf="!efiledData.applicantMatchedId">
            <label for="rollType" class="col-md-1 prd-label">Roll Type</label>
            <input id="rollType" class="form-control col-md-3" [(ngModel)]="efiledData.rollType" readonly>
            <label for="rollYear" class="col-md-1 prd-label">Roll Year</label>
            <input id="rollYear" class="form-control col-md-2" [(ngModel)]="efiledData.rollYear" readonly>
          </div>

            <br />

            <div class="form-row" *ngIf="efiledData.agentDto?.companyName||efiledData.agentDto?.lastName">
                <div class="col-md-2 offset-1">
                    <b>Agent</b>
                </div>
                <div class="form-row">
                    <label for="companyName" class="col-md-2 col-form-label prd-label">Company</label>
                    <input id="companyName" class="form-control col-md-6" [(ngModel)]='efiledData.agentDto.companyName' readonly>
                </div>
                <div class="form-row">
                    <label for="agentName" class="col-md-2 col-form-label prd-label">Agent Name</label>
                    <input id="agentName" class="form-control col-md-6" value='efiledData.agentDto.firstName' readonly>
                </div>

                <div class="form-row">
                    <label for="agencyAddr" class="col-md-2 col-form-label prd-label">Address</label>
                    <input id="agencyAddr" class="form-control col-md-6" value='efiledData.agentDto.mailingAddress' readonly>
                </div>
                <hr />
                <div class="col-md-8" style="background-color: white; border:thin">
                    <div class="row">
                        <div class="col-md-2">
                            Company
                        </div>
                        <div class="col-md-6">
                            <b>{{efiledData.agentDto.companyName}}</b>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            Agent Name
                        </div>
                        <div class="col-md-6">
                            <b>{{efiledData.agentDto.firstName}}{{efiledData.agentDto.lastName}}</b>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            Address
                        </div>
                        <div class="col-md-6">
                            <b>{{efiledData.agentDto.mailingAddress}}{{efiledData.agentDto.city }}</b>
                        </div>
                    </div>

                </div>
            </div>

            <br />

            <!-- Buttons -->
            <div class="row">
                <div class="col-md-2 offset-2">
                    <button class="btn btn-warning" (click)="cancelImport()">Cancel Import</button>
                </div>
                <div class="col-md-3 offset-1">
                    <button  class="btn btn-success" (click)="postApplication()" title="Post application to appeals management database.">Import Application</button>
                </div>
            </div>

            <br />

        </div>


        <!-- Error Message -->
        <div class="row">
            <div class="col-md-offset-3 col-md-9 text-danger" *ngIf="displayState.errorMessage!=''"><p>{{displayState.errorMessage}}</p>  </div>
        </div>
        <br />
        <br />

    </div>
</div>
